import { AnnualReportTemplate } from '@modeso/types__aumico-lib-annualreport-be';
import { PDFSectionIds } from '../../public-api';
import { IPdfTronData } from '../interfaces/pdf-tron/pdf-tron-data.interface';

export interface PrintUsingPdfTronDto {
    data: IPdfTronData;
    orderedSectionsTitles: string[];
    orderedSectionsIds: PDFSectionIds[];
    annualReportId?: string | null;
    annualReportTemplateId?: string | null;
    // Business model of the template copy on the report — the export renders with the same one the preview shows.
    businessModel?: AnnualReportTemplate['businessModel'] | null;
}
